import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function ProjectKpiDrawer() {

  const [open, setOpen] = useState(true);

  const drawerWidth = open ? "260px" : "36px";

  const containerStyle = {
    position: "fixed",
    top: "60px",
    right: "0",
	bottom:'0px',
    width: drawerWidth,
    background: "linear-gradient(180deg, #323740 0%, #272b31 100%)",
    borderLeft: "1px solid rgba(255,255,255,0.08)",
    color: "#fff",
    boxShadow: "-10px 0 25px rgba(0,0,0,0.45)",
    zIndex: 900,
    transition: "width 0.25s ease",
    //overflow: "hidden",
    display: "flex",
    flexDirection: "column",
	borderTopLeftRadius:'10px',
	borderBottomLeftRadius:'10px'
  };

  const toggleStyle = {
    position: "absolute",
    top: "314px",
    left: "-18px",
    width: "36px",
    height: "36px",
    background: "linear-gradient(180deg, #2b2f35 0%, #1f2329 100%)",
    borderRadius: "50%",
    border: "1px solid rgba(255,255,255,0.15)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 6px 14px rgba(0,0,0,0.5)",
    transition: "transform 0.15s ease"
  };

  const contentStyle = {
    padding: "28px",
    opacity: open ? 1 : 0,
    transition: "opacity 0.2s ease",
    pointerEvents: open ? "auto" : "none"
  };

  const kpiTileStyle = {
    background: "linear-gradient(180deg, #3a3f47 0%, #343941 100%)",
    borderRadius: "8px",
    padding: "14px 16px",
    marginBottom: "14px",
    border: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.05)"
  };
  
  const drawerSectionSpacer = {
    height: "14px"
  };

  return (
    <div style={containerStyle}>

      {/* TOGGLE BUTTON */}
      <div style={toggleStyle} onClick={() => setOpen(!open)}
	  onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
	  onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}>
	  <FontAwesomeIcon
	    icon={open ? faChevronRight : faChevronLeft}
	    style={{ color: "#ffffff", fontSize: "12px", opacity: 0.85 }}
	  />
      </div>

      {/* CONTENT */}
      <div style={contentStyle}>
        <div style={{ fontSize: "14px", fontWeight: 600, opacity: 0.85, marginBottom: "28px" }}>
          PROJECT KPIs
        </div>
		<div style={{
		  height: "1px",
		  background: "linear-gradient(90deg, rgba(255,255,255,0.15), rgba(255,255,255,0.02))",
		  marginBottom: "18px"
		}} />
		{[
		  ["Assets Allocated", "72%"],
		  ["Desks Allocated", "65%"],
		  ["People Assigned", "80%"]
		].map(function (row) {
		  return (
		    <div key={row[0]} style={kpiTileStyle}>
		      <div style={{ fontSize: "12px", opacity: 0.75 }}>{row[0]}</div>
		      <div style={{ fontSize: "26px", fontWeight: 700, color: "#2F80ED", marginTop: "4px" }}>
		        {row[1]}
		      </div>
		    </div>
		  );
		})}
		<div style={drawerSectionSpacer} />
        <div style={{
          marginTop: "30px",
          paddingTop: "20px",
          borderTop: "1px solid rgba(255,255,255,0.08)"
        }}>
          <div style={{ fontSize: "13px", opacity: 0.7 }}>Readiness</div>
          <div style={{ fontSize: "20px", fontWeight: 600, color: "#f39c12" }}>
            At Risk
          </div>
        </div>
      </div>

    </div>
  );
}
